import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { Base64 } from 'js-base64';
import vbMsgBox from 'bootstrap-vue-msgbox'
import VeeValidate from 'vee-validate'
import store from './store'
import router from "./router";
import DisableAutocomplete from '@/views/mixins/vue-disable-autocomplete';
import '@/styles/index.scss' // global css
import { cookieConsentManager } from './utils/CookieConsentManager'

cookieConsentManager.init({
  privacyPolicyUrl: 'https://lifehikes.com/privacy-policy/'
})
// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
//import './permission' // permission control
import VueGtag, { optIn, optOut } from 'vue-gtag'
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
Vue.use(vbMsgBox)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(router)
Vue.use(VeeValidate, {
  // This is the default
  inject: true,
  // Important to name this something other than 'fields'
  fieldsBagName: 'veeFields',
  // This is not required but avoids possible naming conflicts
  errorBagName: 'veeErrors'
})
Vue.use(DisableAutocomplete);
Vue.config.productionTip = false
Vue.prototype.$Base64 = Base64
const hasAnalyticsConsent = cookieConsentManager.hasConsent('analytics')

Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GA_ID,
    params: {
      cookie_domain: 'none',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: hasAnalyticsConsent ? 'granted' : 'denied'
    }
  },
  pageTrackerScreenviewEnabled: true,
  appName: 'LifeHikes SSO Portal',
  enabled: hasAnalyticsConsent
}, router)

cookieConsentManager.onConsentChange(() => {
  const hasConsent = cookieConsentManager.hasConsent('analytics')
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('consent', 'update', {
      analytics_storage: hasConsent ? 'granted' : 'denied'
    })
  }
  if (hasConsent) {
    optIn()
  } else {
    optOut()
  }
})
window._app = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
